<template>
    <div>
        <b-table
            :items="items"
            :fields="fields"
            responsive
            :busy="isLoading"
            class="scroll-bar-mkt"
        >
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                </div>
            </template>
            <template #cell(job_name)="row">
                <h5>{{ row.item.job_name }}</h5>
                <div class="text-muted">HUB-{{ row.item.id }}</div>
            </template>
            <template #cell(net)="row">
                <h3>{{ Number(row.item.net) | number }}
                    <span class="h5 text-muted"> บาท</span>
                </h3>
            </template>
        </b-table>
        <b-row>
            <b-col class="d-flex justify-content-center">
                <b-pagination
                    v-model="pagination.currentPage"
                    :disabled="isLoading"
                    :total-rows="pagination.totalRows"
                    :per-page="pagination.perPage"
                    aria-controls="my-table"
                    class="mt-3"
                    @change="(page) => getReportJobDriver(page)"
                ></b-pagination>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import jobServices from "@/api/job.service.js";

export default {
    props:{
        search: {
            type: Object
        },
        pagination: {
            type: Object
        }
    },
    data() {
        return {
            isLoading: false,
            fields: [
                {
                    key: "job_name",
                    label: "ชื่องาน/รหัสงาน",
                    class: 'text-left h5'
                },
                {
                    key: "distance",
                    label: "ระยะทาง (กม.)",
                    class: 'text-left h5'
                },
                {
                    key: "net",
                    label: "ราคาสุทธิ",
                    class: 'text-center h5'
                }
            ],
            items: []
        }
    },
    created() {
        this.getReportJobDriver();
    },
    methods:{
        async getReportJobDriver(page = 1){
            this.isLoading = true;
            try {
                const { data } = await jobServices.getReportJobByDriver({
                    started_datetime: this.search.dateStart,
                    ended_datetime: this.search.dateEnd,
                    page,
                })

                this.items = data.data.items;
                this.pagination.totalRows = data.data.meta.totalItems;
                this.pagination.perPage = data.data.meta.itemsPerPage;
                this.pagination.currentPage = data.data.meta.currentPage;
                this.isLoading = false;
            } catch (error) {}
        }
    }
}
</script>
